import omit from 'ramda/src/omit'
import path from 'ramda/src/path'
import compose from 'ramda/src/compose'
import converge from 'ramda/src/converge'
import identity from 'ramda/src/identity'
import when from 'ramda/src/when'
import objOf from 'ramda/src/objOf'

const omittedKeys = ['aspectRatio', 'focalLength', 'horizontalFieldOfView',
  'markers', 'ppf', 'remove', 'verticalFieldOfView', 'verticalAngleOfView', 'ppfHoverPosition', 'newlyAdded']

const addIfKeyExists = (key, p) =>
  when(
    path(p),
    compose(objOf(key), path(p))
  )

export default
  compose(
    omit(['model']),
    converge(
      Object.assign, [
        identity,
        addIfKeyExists('modelId', ['model', 'id']),
        addIfKeyExists('modelAovId', ['model', 'aov', 'id'])
      ]),
    omit(omittedKeys)
  )



// WEBPACK FOOTER //
// ./src/helpers/projects/compressCamera.js